import React from 'react';
import { Box, CardActionArea, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import CloudinaryImage from '../../../DesignSystem/CloudinaryImage';

const LOGO_WIDTH = 80;
const LOGO_HEIGHT = 32;

function Affiliate({ affiliate }: any) {
  return (
    <CardActionArea
      href={affiliate.shareable_url}
      sx={{
        borderRadius: 8,
        flexGrow: 1,
        flexShrink: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1.5,
        }}
      >
        <Box sx={{ mr: 2 }}>
          <CloudinaryImage
            publicId={affiliate.brand_logo?.s3_key}
            height={LOGO_HEIGHT}
            width={LOGO_WIDTH}
            alt=""
            transformation={`w_${LOGO_WIDTH},h_${LOGO_HEIGHT},c_lpad,q_auto:low`}
          />
        </Box>

        <Box>
          <Typography color="textPrimary" sx={{ fontWeight: 'medium' }}>
            {affiliate.name}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {affiliate.entity_type}
          </Typography>
        </Box>
      </Box>
    </CardActionArea>
  );
}

Affiliate.propTypes = {
  affiliate: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    brand_logo: PropTypes.shape({
      s3_key: PropTypes.string,
    }),
  }).isRequired,
};
export default Affiliate;
